import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { WorkspaceRole } from '../models/users';

export const UserRoleChange = createAction(
  '[UserRoleChange] Delete',
  props<{ workspaceId: string; userId: string; role: WorkspaceRole }>()
);
export const UserRoleChanged = createAction('[UserRoleChange] Deleted', props<{ userId: string }>());
export const UserRoleChangeError = createAction('[UserRoleChange] Delete Error', props<{ userId: string }>());

export const initialState: Record<string, CommonApiState<undefined>> = {};

export const userRoleChangeFeature = createFeature({
  name: 'userRoleChange',
  reducer: createReducer(
    initialState,
    on(UserRoleChange, (state, action) => ({
      ...state,
      [action.userId]: {
        ...(state[action.userId] ?? {}),
        currentPedingApis: (state[action.userId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(UserRoleChanged, (state, action) => {
      return {
        ...state,
        [action.userId]: {
          ...(state[action.userId] ?? {}),
          currentPedingApis: 0,
          isError: false
        }
      };
    }),
    on(UserRoleChangeError, (state, action) => {
      return {
        ...state,
        [action.userId]: {
          ...(state[action.userId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectUserRoleChangeState }) => {
    const userRoleChangeIsBeingChanged = (userId: string) =>
      createSelector(
        selectUserRoleChangeState,
        userRoleChangeState => (userRoleChangeState[userId]?.currentPedingApis ?? 0) > 0
      );

    const userRoleChangesAreBeingChanged = createSelector(selectUserRoleChangeState, userRoleChangeState => {
      return Object.entries(userRoleChangeState).reduce((curr, [userId, value]) => {
        return { ...curr, [userId]: value.currentPedingApis > 0 };
      }, {});
    });

    const userRoleChangeHasPendingRequest = (userId: string) =>
      createSelector(
        selectUserRoleChangeState,
        userRoleChangeState => (userRoleChangeState[userId]?.currentPedingApis ?? 0) >= 2
      );

    return {
      userRoleChangeIsBeingChanged,
      userRoleChangeHasPendingRequest,
      userRoleChangesAreBeingChanged
    };
  }
});
